interface Props {
  tone?: 'info' | 'warning' | 'error' | 'success';
  children: React.ReactNode;
}

export function Banner({ tone = 'info', children }: Props) {
  return (
    <div className={`banner banner--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
